var EvaluationService = require('services/evaluation-service');

var SurveyService = function () {
  this.getRedirectUrlForCurrentPage = function () {
    var currentPage = EF.module.currentActivity.currentPage ? EF.module.currentActivity.currentPage.path() : '';
    var redirectUrl = `#${currentPage}?surveyTaken=true`;
    return redirectUrl;
  };

  this.triggerSurvey = function (blockView) {
    var redirectUrl = this.getRedirectUrlForCurrentPage();
    var data = {
      event_type: 'survey-initialized',
      redirectUrl: redirectUrl,
      slug: blockView.model.get('slug'),
    };
    window.postMessage(data, window.location.origin);
  };

  this.userHasCompletedSurvey = function (courseSlug) {
    return EvaluationService.userHasCompletedEvaluation(courseSlug);
  };

  this.getSurvey = function (blockView) {
    return EvaluationService.expandedResponseSet(blockView.model.get('slug')).then(() => {
      const surveyResponseModel = EvaluationService.findEvaluationBySlug(blockView.model.get('slug'));
      const foundryAllowAnswerChange = surveyResponseModel.get('evaluation').allow_changing_answers;
      if (foundryAllowAnswerChange !== undefined) {
        surveyResponseModel.set('allow_answer_change', foundryAllowAnswerChange);
      }
      let survey = _.pick(surveyResponseModel.attributes, ['slug', 'answers', 'sections', 'questions']);
      var responseSet = EvaluationService.getResponseSetFromModel(blockView.model.get('slug'));
      blockView.model.set('responseSet', surveyResponseModel);
      // sections is not set on the survey model for some reason
      // this has to be handled here or in the template
      blockView.model.set('translate', false);
      blockView.model.get('survey').set('sections', surveyResponseModel.get('sections'));
      blockView.render();
    });
  };

  this.saveSurveyResponse = function (blockView, dataset, opts) {
    const surveyResponseModel = EvaluationService.findEvaluationBySlug(blockView.model.get('slug'));
    let options;
    if (opts && opts.multipleQuestion) {
      options = surveyResponseModel.save(dataset);
    } else {
      options = surveyResponseModel.save([{ question_id: dataset.questionId, answer_id: dataset.answerId }]);
    }
    return Backbone.Model.prototype.save.call(surveyResponseModel, options.attrs, options);
  };
  this.refreshResponseSet = function (slug) {
    EvaluationService.refreshResponseSet(slug);
  };
};

module.exports = new SurveyService();
